export default __webpack_public_path__ + "static/Signerica_Fat-3f013c834ac2c7803f928ed3e96c40b9.ttf";